import { SVGProps, Ref, forwardRef } from 'react';

export const KeyFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8 6.8c.483 0 .772.124.91.24.08.066.29.268.29.96s-.21.894-.29.96c-.138.116-.427.24-.91.24s-.772-.124-.91-.24c-.08-.066-.29-.268-.29-.96l.01-.237c.04-.504.21-.665.28-.724.138-.115.427-.24.91-.24"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 1c4 0 8 2 8 8 0 .782-.07 1.495-.196 2.146L18 12.342V14h1.658l.342.342V16h1.657L23 17.343V21.5L17.343 23l-6.206-6.207C10.44 16.934 9.72 17 9 17c-4 0-8-2-8-8s4-8 8-8M8 5c-1.5 0-3 .75-3 3s1.5 3 3 3 3-.75 3-3-1.5-3-3-3"
            fill="currentColor"
        />
    </svg>
));
KeyFilledSize24Glyph.displayName = 'KeyFilledSize24Glyph';
